<div class="px-4 px-md-5 px-xxl-4">
    <div class="content-section">
        <div>
          <app-crumbs [crumbs]="crumbs"></app-crumbs>
        </div>
        <div class="d-flex flex-column flex-lg-row content-categorie" style="position: relative;">
            <div class="content-filter">
                <div class="filters">
                    <div class="btn-categorie bg-sky d-flex al-center sp-center mb-3">
                        <span class="text-white fs-4 fw-semibold">{{products.general.title}}</span>
                    </div>
                    <!-- <div class="p-3 bg-gray content-features">
                        <div class="d-flex content-subcategories">
                            <div class="bg-red categorie d-flex al-center sp-center w-100">
                                <span class="text-white fw-semibold">{{products.general.types.length}} {{products.general.subcategories[0]}}</span>
                            </div>
                            <div class="bg-blue categorie d-flex al-center sp-center w-100">
                                <span class="text-white fw-semibold">{{products.general.subcategories[1]}}</span>
                            </div>
                        </div>
                        <div class="d-flex content-subcategories">
                            <div class="d-flex w-100" *ngFor="let caption of products.general.captions">
                                <img [src]="caption.icon" width="20" class="me-2" alt="">
                                <span class="fs-7 fw-regular">{{caption.name}}</span>
                            </div>
                        </div>
                    </div> -->
                    <div class="px-5 pb-4">
                        <div *ngFor="let type of products.general.types; let i = index" class="mt-4">
                            <div class="d-flex al-center sp-between animated" [ngClass]="typeCurrent == i+1 ? '':'disabled' ">
                                <div (click)="setTypeCurrent(i+1, type)">
                                    <img [src]="type.icon" class="me-3" alt="">
                                    <span class="text-blue fw-bold pointer">{{type.name}}</span>
                                </div>
                                <div *ngIf="type.subcategories.length > 0">
                                    <img src="assets/svg/arrow-right.svg" class="pointer animated" (click)="type.expand = !type.expand" [ngClass]=" type.expand ? 'arrow-up':'arrow-down'" alt="">
                                </div>
                            </div>
                            <ng-container *ngIf="type.subcategories.length > 0 && type.expand">
                                <div class="content-options pt-4" [ngClass]="typeCurrent == 2 ? '':'disabled' ">
                                    <div class="ps-4 py-4 content-border">
                                        <div *ngFor="let sub of type.subcategories; let i=index" [ngClass]="sub.selected ? 'bg-gray':''" class="px-4 mb-2 content-sub d-flex al-center pointer animated" (click)="showProducts(type, i+1)">
                                            <span class="text-blue fw-bold">{{sub.label}}</span>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
            <div class="products d-flex flex-column w-100">
                <div class="content-product w-100 d-flex flex-column flex-xl-row mb-4" *ngFor="let productSelected of listProducts">
                    <div class="content-image d-flex flex-column al-center justify-content-center" style="background-image: url({{productSelected.background}});">
                        <img [src]="productSelected.image" class="image-product"  alt="">
                        <div class="w-100 d-flex flex-column sp-center al-center">
                            <div class="pb-0 pb-sm-5">
                                <span class="text-sky fw-regular fs-5">{{productSelected.flavor}}</span>
                            </div>
                            <!-- <div class="action bg-blue d-flex al-center sp-center w-100">
                                <span class="text-white fw-medium fs-5">{{productSelected.action}}</span>
                            </div> -->
                        </div>
                    </div>
                    <div class="product-description d-flex flex-column sp-between w-100 h-100">
                        <div class="h-100 content-responsive">
                            <div class="border-bottom" style="margin-bottom: 24px;">
                                <span class="fs-2 fw-bold text-blue">{{productSelected.steps[0].title}}</span>
                            </div>
                            <ng-container *ngIf="!productSelected.steps[0].description">
                                <div class="h-100 d-flex flex-column sp-center al-center pb-5">
                                    <span class="fw-semibold fs-1 mb-5">{{productSelected.steps[0].general.title}}</span>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="productSelected.steps[0].description">
                                <ng-container *ngIf="productSelected.pageCurrent == 1">
                                    <div style="margin-bottom: 16px;">
                                        <span class="fw-regular" style="line-height: 22px;">{{productSelected.steps[0].description}}</span>
                                    </div>
                                    <div class="d-flex content-icons" style="margin-bottom: 20px">
                                        <img src="assets/svg/carbohidratos-icon.svg" width="40" alt="" [ngClass]=" type.id == 1 ? 'enabled':'disabled'">
                                        <img src="assets/svg/proteina-icon.svg" width="40" alt="" [ngClass]=" type.id == 2 ? 'enabled':'disabled'">
                                        <img src="assets/svg/fibra-icon.svg" width="40" alt="" [ngClass]=" type.id == 3 ? 'enabled':'disabled'">
                                        <img src="assets/svg/grasa-icon.svg" width="40" alt="" [ngClass]=" type.id == 4 ? 'enabled':'disabled'">
                                    </div>
                                    <div style="margin-bottom: 16px;">
                                        <span class="fw-semibold fs-5">{{productSelected.steps[0].general.title}}</span>
                                    </div>
                                    <div style="margin-bottom: 8px;">
                                        <span class="fw-regular" style="line-height: 22px;">{{productSelected.steps[0].general.description}}</span>
                                    </div>
                                    <div>
                                        <div class="d-flex al-center" *ngFor="let bullet of productSelected.steps[0].general.features" style="margin-top: 4px;">
                                            <img src="assets/svg/bullet.svg" class="me-2" width="12" alt="">
                                            <span class="fw-regular">{{bullet}}</span>
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="productSelected.pageCurrent == 2">
                                    <div>
                                        <span class="fw-semibold fs-5">{{productSelected.steps[1].indications.title}}</span>
                                    </div>
                                    <div>
                                        <span class="fw-regular" style="line-height: 22px;">{{productSelected.steps[1].indications.description}}</span>
                                    </div>
                                    <div style="margin-top: 18px;">
                                        <span class="fw-semibold fs-5">{{productSelected.steps[1].presentation.title}}</span>
                                    </div>
                                    <div>
                                        <div class="d-flex al-center" *ngFor="let bullet of productSelected.steps[1].presentation.features" style="margin-top: 4px;">
                                            <img src="assets/svg/bullet.svg" class="me-2" width="12" alt="">
                                            <span class="fw-regular">{{bullet}}</span>
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="productSelected.pageCurrent == 3">
                                    <div class="mb-1">
                                        <span class="fw-semibold fs-5">{{productSelected.steps[2].instructions.title}}</span>
                                    </div>
                                    <div>
                                        <span class="fw-regular" style="line-height: 22px;">{{productSelected.steps[2].instructions.description}}</span>
                                    </div>
                                    <br>
                                    <div class="mb-1">
                                        <span class="fw-semibold fs-5">{{productSelected.steps[2].conservation.title}}</span>
                                    </div>
                                    <div>
                                        <span class="fw-regular" style="line-height: 22px;">{{productSelected.steps[2].conservation.description}}</span>
                                    </div>
                                </ng-container>
                            </ng-container>
                        </div>
                        <ng-container *ngIf="productSelected.steps[0].description">
                            <div class="content-steps d-flex sp-center">
                                <div class="content-pag d-flex al-center sp-center pointer animated" [ngClass]="productSelected.pageCurrent == i+1 ? 'bg-blue':'inactive'" 
                                *ngFor="let pagination of productSelected.steps; let i = index" (click)="nextPage(i+1, productSelected)">
                                    <span class="fw-bold animated" [ngClass]="productSelected.pageCurrent == i+1 ? 'text-white':'text-blue'">{{i+1}}</span>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br><br><br><br>
</div>